
import { useMutation, useQueryClient } from 'react-query';
import dealEventService from 'resources/deal-event/deal-event.service';

export default function useCreateDealEvent() {
  const queryClient = useQueryClient();

  return useMutation(
    (data) => dealEventService.createDealEvent(data),
    {
      onSuccess: (response) => {
        if (response.deal_id) {
          queryClient.invalidateQueries(['deal-event.getByDealId', response.deal_id]);
        }
      },
    },
  );
}

